module.exports = __webpack_public_path__ + "img/id-qtv-3.3e13bcea.webp";